import 'console-polyfill';
import 'es5-shim';
import './services/ObjectAssign';
import './modules/modernizr';

import FastClick from 'fastclick';
import $ from 'jquery';

// jquery utils
import 'jquery.easing';

import './plugins/nette.ajax';
import './plugins/giant.trigger';
import './plugins/giant.autosubmit';

import antispam from './modules/antispam';

// nette
import './nette/NetteFormFilled';
import './nette/NetteForms';
import './nette/NetteValidationMessages';
import './nette/NetteSnippets';

import Nette from './nette/NetteForms';
window.Nette = Nette;
Nette.initOnLoad();

if ($.nette) {
    $.nette.init();
}

import components from './components/';
import { loadComponents } from './core/componentUtils';

window.app = {
    components: components
};

FastClick.attach(document.body);
loadComponents();


// xhr
import Xhr2 from './core/xhr2';

let options = {
    LINK_SELECTOR: 'a[href^="/"]:not([data-no-xhr2]):not(.ajax), a[href^="#"]:not([data-no-xhr2]), a[xlink\\:href]',
    elements: ['#xhr', '#header', '.guide__illustration', '.guide__number', '.guide-mobile__illustration', '.guide-mobile__number'],
    cache: false,
    animationSelector: '.page-wrapper, .footer',
    pageClassPrefix: 'page-',
    scroll: true,
    debugMode: true,
    preload: false,
    support: true,
    animateScrollToAnchor: true,
    doScrollingRightAway: true,
    animateScrollOnMobile: true
}

const xhr2 = new Xhr2(options)

document.addEventListener('xhr2:contentReplaced', event => {
    xhr2.elements.forEach((element) => {
        loadComponents(document.querySelector(element))
    })
    if ($.nette) {
        if ($.nette) {
            $.nette.ext('snippets').afterQueue.fire($('body'))
            $.nette.load()
        }
    } else {
        console.warn('Nette is not loaded.')
    }
});




// WEBPACK FOOTER //
// ./app.js